<i [class]="`bi ${Icon} m-0 p-0`"></i>
<span>
  <ng-content></ng-content>
</span>
